import { createSlice } from '@reduxjs/toolkit';
import { isRehydrateOnHome } from 'modules/app/utils';

type InitialState = {
  isRestrictedAccessModalOpen: boolean;
};

const initialState: InitialState = {
  isRestrictedAccessModalOpen: false,
};

const restrictedAccessSlice = createSlice({
  name: 'restrictedAccess',
  initialState,
  reducers: {
    openRestrictedAccessModal: (state) => ({
      ...state,
      isRestrictedAccessModalOpen: true,
    }),
    continueRestrictedAccessModal: (state) => ({
      ...state,
      isRestrictedAccessModalOpen: true,
    }),
    closeRestrictedAccessModal: (state) => ({
      ...state,
      isRestrictedAccessModalOpen: false,
    }),
  },
  extraReducers: (builder) => {
    builder.addMatcher(isRehydrateOnHome, (state) => ({ ...state, isRestrictedAccessModalOpen: false }));
  },
});

export default restrictedAccessSlice;
